export default "__VITE_ASSET__DAl9WPIQ__"